import Carousel from 'react-bootstrap/Carousel';
import imagen1 from '../assets/images/carousel/1.jpg';
import imagen2 from '../assets/images/carousel/2.jpg';
import imagen3 from '../assets/images/carousel/3.jpg';
import '../assets/css/carousel.css'



function Carousels() {
  return (
    <Carousel >
      <Carousel.Item>
        <img className='img-carousel d-block w-100 ' height='auto' src={imagen1}/>
        <Carousel.Caption>
          <h3 className='subtitulo-carousel'><span className='titulo-carousel'>M & Z</span> tapizados</h3>
          <p className='subtitulo'>General | Automotor | Antigüedades</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img className='img-carousel d-block w-100' height='auto'src={imagen2}/>
        <Carousel.Caption>
        <h3 className='subtitulo-carousel'><span className='titulo-carousel'>M & Z</span> tapizados</h3>
          <p className='subtitulo'>General | Automotor | Antigüedades</p>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
      <img className='img-carousel d-block w-100' height='auto'src={imagen3}/>
        <Carousel.Caption>
        <h3 className='subtitulo-carousel'><span className='titulo-carousel'>M & Z</span> tapizados</h3>
          <p className='subtitulo'>
          General | Automotor | Antigüedades
          </p>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}

export default Carousels;